var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.895,
    height: 106.453,
    viewBox: "0 0 117.895 106.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.105 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.6,41.858V96.033a10.476,10.476,0,0,1-3.74,7.593,10.745,10.745,0,0,1-7.138,2.72H13.484a10.219,10.219,0,0,1-5.212-1.36,7.436,7.436,0,0,1-1.926-1.36A9.138,9.138,0,0,1,3.512,99.66a9.345,9.345,0,0,1-.793-3.513V41.858S7.252,38,13.711,32.678C20.4,27.011,29.235,19.757,36.94,13.3c4.419-3.74,3.966-3.287,10.765-9.067a14.177,14.177,0,0,1,18.017,0c1.36,1.133,2.72,2.38,4.079,3.513,2.833,2.267,5.892,4.987,9.292,7.707,6.912,5.78,14.5,12.127,20.51,17.114C105.722,37.664,110.142,41.4,110.6,41.858Z",
    fill: "#547dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.751,17.264V51.038L78.527,61.352l-5.1,3.06-10.878,6.46-5.1,3.173L55.3,75.292l-2.04-1.247-4.873-3.06-10.312-6.46L33.2,61.465,17.337,51.492V17.264A6.457,6.457,0,0,1,23.8,10.8h65.5A6.457,6.457,0,0,1,95.751,17.264Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.45,43.1V17.264a6.457,6.457,0,0,1,6.459-6.46H89.4a6.457,6.457,0,0,1,6.459,6.46V43.785",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.813,35.85H33.428a1.591,1.591,0,0,1,0-3.173H81.813a1.591,1.591,0,0,1,0,3.173Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.813,45.371H33.428a1.591,1.591,0,0,1,0-3.173H81.813a1.591,1.591,0,0,1,0,3.173Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.813,54.891H33.428a1.591,1.591,0,0,1,0-3.173H81.813a1.591,1.591,0,0,1,0,3.173Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.64,61.352l-5.1,3.06H38.187l-4.873-3.06H78.64Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.663,70.872,57.45,74.045H53.258l-4.873-3.173Z",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.275,24.97H43.853a1.527,1.527,0,0,1-1.473-1.586,1.428,1.428,0,0,1,1.473-1.473H71.275A1.527,1.527,0,0,1,72.748,23.5,1.428,1.428,0,0,1,71.275,24.97Z",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,41.858V96.033a10.476,10.476,0,0,1-3.74,7.593,10.745,10.745,0,0,1-7.138,2.72H13.484a10.219,10.219,0,0,1-5.212-1.36,7.436,7.436,0,0,1-1.926-1.36A9.138,9.138,0,0,1,3.512,99.66a9.345,9.345,0,0,1-.793-3.513V41.858L50.991,72.119l4.193,2.607,1.473-.907,1.36-.793Z",
    fill: "#738dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.855,103.626a10.745,10.745,0,0,1-7.138,2.72H13.484a10.219,10.219,0,0,1-5.212-1.36,7.436,7.436,0,0,1-1.926-1.36A9.138,9.138,0,0,1,3.512,99.66a9.345,9.345,0,0,1-.793-3.513V41.858l5.666,3.4L56.657,73.932l1.36.793.113.113,43.286,25.614Z",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.745,46.051,49.065,69.4",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,41.858V96.033a10.476,10.476,0,0,1-3.74,7.593,10.745,10.745,0,0,1-7.139,2.72H13.484a10.219,10.219,0,0,1-5.212-1.36,7.436,7.436,0,0,1-1.926-1.36L11.9,100.34,55.184,74.726l1.473-.907,1.36-.793,47.025-27.881Z",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.929,45.258,57.9,73.025l-1.36.793-1.473.907L14.731,98.64",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.563,79.712H68.895a1.246,1.246,0,1,1,0-2.493H97.563a1.246,1.246,0,1,1,0,2.493Z",
    fill: "#547dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.563,87.985H68.895a1.246,1.246,0,1,1,0-2.493H97.563a1.246,1.246,0,1,1,0,2.493Z",
    fill: "#547dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.606,54.892V41.858c4.306-3.627,7.932-6.687,10.992-9.18",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.13,31.431c6.912,5.78,12.238,10.2,12.465,10.427V96.033a10.925,10.925,0,0,1-10.878,10.313c-92.918,0-89.179,1.02-93.371-2.72a11.1,11.1,0,0,1-3.739-7.48V65.885",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.493,8.537c1.473-1.247,3.173-2.72,5.212-4.307a14.177,14.177,0,0,1,18.017,0c.453.453,3.513,2.947,7.819,6.574",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.694,36.758a4.307,4.307,0,1,0-4.306-4.307A4.306,4.306,0,0,0,115.694,36.758Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.709,18.51A1.813,1.813,0,1,0,108.9,16.7,1.813,1.813,0,0,0,110.709,18.51Z",
    fill: "#e2ebff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.49f6850b5b9d61f21a8d705600a8bb34.svg";
export { ForwardRef as ReactComponent };